// extracted by mini-css-extract-plugin
export default {"googleLoginContainer":"GoogleLoginButton_googleLoginContainer__yFXn3","googleLoginIcon":"GoogleLoginButton_googleLoginIcon__Ex6Pp"};